import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {useStyle} from 'src/providers/style';
import {Colors, Typography} from 'src/styles';
import {RHAvatar} from 'src/common-components/custom-ui-helpers';
import {Separator} from 'src/common-components/atoms';
import {useNavigation} from '@react-navigation/native';

const AuthorizationProgressItem = ({patient, statusText}: any) => {
  const styles = useStyle();
  const navigation = useNavigation();

  const firstName = patient?.firstName;
  const lastName = patient?.lastName;
  const firstInitial = firstName?.length > 0 ? firstName[0].toUpperCase() : 'N';
  const lastInitial = lastName?.length > 0 ? lastName[0].toUpperCase() : 'N';
  const initials = firstInitial + lastInitial;

  if (!statusText) {
    return null;
  }

  return (
    <TouchableOpacity
      onPress={() =>
        navigation.navigate('PatientProfile', {
          screen: 'Authorizations',
          patientId: patient?.id,
        })
      }>
      <View style={[styles.paddingVertical, styles.flex]}>
        <View style={[styles.row, styles.alignCenter]}>
          <View style={[styles.flex, styles.row, styles.alignCenter]}>
            <RHAvatar
              label={initials}
              color={Colors.RAVEN_BLACK}
              textColor={Colors.RAVEN_WHITE}
              size={32}
            />
            <Separator width={20} />
            <Text style={Typography.P3}>
              {`${patient?.firstName} ${patient?.lastName}`}
            </Text>
          </View>
          <Text
            style={[Typography.P3_BOLD, styles.textColorError, styles.flex]}>
            {statusText}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default AuthorizationProgressItem;
